
import { Component, Vue } from 'vue-property-decorator'
import appBar from '@/components/AppBar.vue'
import { EmployeeList } from '../models/EmployeeList'

@Component({
	components: { appBar }
})
export default class EmoloyeeMasterView extends Vue {
	//#region 変数
	private search = ''
	private employeeList: EmployeeList[] = []
	private headers = [
        {
            text: '編集',
            value: 'edit',
            width: '5 %',
            class: 'sticky-header primary white--text',
            align: 'center',
            sortable: false,
            divider: true
        },
		{
			text: 'ID',
			value: 'empCd',
			width: '5 %',
			class: 'sticky-header primary white--text',
			align: 'left',
			divider: true
		},
		{
			text: '名前',
			value: 'empNm',
			width: '30 %',
			class: 'sticky-header primary white--text',
			align: 'left',
			divider: true
		},
		{
			text: '所属',
			value: 'divisionNm',
			width: '30 %',
			class: 'sticky-header primary white--text',
			align: 'left',
			divider: true
		},
		{
			text: '雇用形態',
			value: 'empTypeNm',
			width: '15 %',
			class: 'sticky-header primary white--text',
			align: 'left',
			divider: true
		},
		{
			text: '勤務先',
			value: 'workPlace',
			width: '15 %',
			class: 'sticky-header primary white--text',
			align: 'left',
			divider: true
		}
	]
	private selectedEmp: EmployeeList = new EmployeeList()
	//#endregion

	// #region 初期表示
	private async created() {
		this.getUserList()
	}
	//#endregion

	//#region 新規追加ボタン押下
	private newEmp() {
		this.$router.push({ name: 'EmployeeMasterEdit' })
	}
	//#endregion

	// #region 編集ボタン押下
	private onClickEditEmp(item: EmployeeList) {
		var empCd = item.empCd
		this.$router.push({ name: 'EmployeeMasterEdit', params: { empcd: empCd } })
	}
	//#endregion

	// #region 一覧再描画ボタン押下
	private refresh() {
		this.getUserList()
	}
	//#endregion

	//#region プライベート
	//#region 社員一覧取得
	private async getUserList() {
		try {
			const response = await this.$axios.get('api/EmployeeMaster/Search')
			if (response.data.messageData.messageList.length > 0) {
				console.log(response.data.messageData)
			}

			this.employeeList = response.data.searchResult
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion
	//#endregion
}
